import React, { ReactNode } from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '../ui/tooltip'

export interface DropdownItem {
  icon: string
  iconAlt: string
  label: string
  onClick?: () => void
}

export interface OGECardDropdownProps {
  items: DropdownItem[]
  isVisible?: boolean
  isRoomLocked?: boolean
  trigger?: ReactNode
  contentClassName?: string
  triggerClassName?: string
  align?: 'start' | 'end' | 'center'
  side?: 'top' | 'right' | 'bottom' | 'left'
}

const OGECardDropdown: React.FC<OGECardDropdownProps> = ({
  items,
  isVisible = true,
  isRoomLocked = false,
  trigger,
  contentClassName = 'h-auto',
  triggerClassName = '',
  align = 'end',
  side = 'bottom',
}) => {
  const defaultTriggerClass = `
    ${isVisible ? 'visible' : 'invisible'}
    flex items-center justify-center
    h-5 w-5
    transition-colors duration-200
    data-[state=open]:bg-[#7bbcd5]
    bg-[url('/icons/three-vertical-dots-white.svg')]
    data-[state=open]:bg-[url('/icons/three-vertical-dots.svg')]
    bg-center bg-no-repeat
    rounded-full
    cursor-pointer
  `

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        className={trigger ? triggerClassName : defaultTriggerClass}
      >
        {trigger}
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className={contentClassName}
        align={align}
        side={side}
      >
        {items.map((item, index) => {
          const isDeleteDisabled = isRoomLocked && item.label === 'Delete Game'

          if (isDeleteDisabled) {
            return (
              <TooltipProvider key={index} delayDuration={200}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div>
                      <DropdownMenuItem disabled className='cursor-not-allowed'>
                        <div className='flex items-center gap-1'>
                          <img
                            src={item.icon}
                            alt={item.iconAlt}
                            className='h-[0.94rem] w-4'
                          />
                          <span className='text-xs text-[#43536A]'>
                            {item.label}
                          </span>
                        </div>
                      </DropdownMenuItem>
                    </div>
                  </TooltipTrigger>
                  <TooltipContent side='left'>
                    <p className='text-xs'>Unlock the game to delete</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            )
          }

          return (
            <DropdownMenuItem
              key={index}
              onClick={item.onClick}
              className='cursor-pointer'
            >
              <div className='flex items-center gap-1'>
                <img
                  src={item.icon}
                  alt={item.iconAlt}
                  className='h-[0.94rem] w-4'
                />
                <span className='text-xs text-[#43536A]'>{item.label}</span>
              </div>
            </DropdownMenuItem>
          )
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default OGECardDropdown
